import { MessageBox,Message } from 'element-ui'

let $messageBox = {
    confirm: function(txt, callback) {
        let content = typeof(txt) == 'string' ? txt : txt.content
        let title = typeof(txt) == 'string' ? '温馨提示' : txt.title
        MessageBox.confirm(`<div class="el-alert-content"><span>${content}</span></div>`, {
            customClass: "delDialog",
            confirmButtonClass: "yes",
            cancelButtonClass: "no",
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            showClose:false,
            title:title,
            callback: function(action) {
                if (action == 'confirm') {
                    callback && callback(MessageBox)
                }
            }
        });
    },
    alert: function(txt, callback, htmlTyle=false) {
        if (!txt) return
        MessageBox.alert(txt, {
            customClass: "alert",
            showConfirmButton: false,
            center: true,
            dangerouslyUseHTMLString: htmlTyle,
            callback: function(action) {
                callback && callback()
            }
        });
    },
    point: function(txt,type='success', callback){
        if (!txt) return
        Message({
            message: txt,
            type: type,
            onClose: (action) => {
                callback && callback()
            }
        })
    }
}
export { $messageBox }



// WEBPACK FOOTER //
// ./common/assets/js/modus.js